import '../EasySoftwareSearch/EasySoftwareSearch.scss'

import React, { FunctionComponent, useEffect, useRef } from 'react'
import { searchConfig } from 'Root/puxconfig'
import { t } from 'ttag'
import PuxIcon from '../PuxIcon/PuxIcon'

interface EasySoftwareSearchProps {
  searchType?: 'header' | 'headerRespo' | 'knowledgebase'
}

const GoogleSearch: FunctionComponent<EasySoftwareSearchProps> = (props) => {
  const searchClass =
    `Search--` +
    props?.searchType?.charAt(0)?.toLowerCase() +
    props?.searchType?.slice(1)

  const LOCALE = process.env.LOCALE ? process.env.LOCALE : `en`
  const PROJECT = process.env.PROJECT
    ? process.env.PROJECT
    : `EasyRedmineGatsby`

  const isKnowledeBase = props.searchType === `knowledgebase`

  const searchTriggerId = isKnowledeBase
    ? `knowledgeBaseSearchWidgetTrigger`
    : `searchWidgetTrigger`

  const configId = isKnowledeBase
    ? searchConfig[PROJECT]?.localizedOptions[LOCALE]?.knowledgeBaseConfigId
    : searchConfig[PROJECT]?.localizedOptions[LOCALE]?.configId

  const widgetRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!configId) return

    const interval = setInterval(() => {
      const widget = widgetRef.current
      if (!widget || !widget.shadowRoot) return

      const ucsResults = widget.shadowRoot.querySelector('ucs-results')
      if (ucsResults && ucsResults.shadowRoot) {
        const ucsSearchResults = ucsResults.shadowRoot.querySelector('ucs-search-results')
        if (ucsSearchResults && ucsSearchResults.shadowRoot) {
          let style = ucsSearchResults.shadowRoot.querySelector('#pux-custom-gs')
          if (!style) {
            style = document.createElement('style')
            style.id = 'pux-custom-gs'
            style.innerHTML = `
              .item .rows.citation .title {
                font-size: 1.6rem !important;
              }
              .item .rows .header.citation,
              .item .header.citation {
                font-size: 1.4rem !important;
              }
              .item .rows p.citation,
              .item p.citation {
                font-size: 1.4rem !important;
              }
              .item.citation, .skeletons-container.citation {
                margin: 0px 0 36px !important;
              }
              .item .rows.clickable:hover .title {
                color: #0072ce !important;
              }
            `
            ucsSearchResults.shadowRoot.appendChild(style)
            clearInterval(interval)
          } else {
            clearInterval(interval)
          }
        }
      }
    }, 500)

    return () => clearInterval(interval)
  }, [configId])

  return configId ? (
    <>
      <gen-search-widget
        ref={widgetRef as any}
        configId={configId}
        triggerId={searchTriggerId}
      ></gen-search-widget>

      <div className={`Search ${searchClass}`}>
        {props.searchType === `header` && (
          <div className='Search-icon' id={searchTriggerId}>
            <PuxIcon name='user-interface/search' size={24} decorative />
          </div>
        )}
        <div className='Search-wrapper'>
          {props.searchType === `headerRespo` && (
            <PuxIcon
              className='Search-inlineIcon'
              name='user-interface/search'
              size={16}
              decorative
            />
          )}
          <input
            className='Search-input'
            type='text'
            id={searchTriggerId}
            placeholder={
              props?.searchType === `header` ||
              props?.searchType === `headerRespo`
                ? t`Redmine.Search.Placeholder`
                : t`Redmine.KnowledgeBase.Search.Placeholder`
            }
          />
        </div>
      </div>
    </>
  ) : null
}

export default GoogleSearch
